import ActionTypes from "../Actions/ActionTypes";


let initialState = {
    allSubscriptions: [],
    paymentCards: []
}

const PaymentReducer = (state = initialState, action) => {


    switch (action.type) {
        case ActionTypes.GET_SUBSCRIPTIONS:
            state = { ...state, allSubscriptions: action.payload }
            break;

        case ActionTypes.GET_PAYMENT_CARDS:
            state = { ...state, paymentCards: action.payload }
            break;

        case ActionTypes.UPDATE_PAYMENT_CARDS:
            let updatedCardList = [...state.paymentCards]
            updatedCardList.unshift(action.payload)
            state = { ...state, paymentCards: updatedCardList }
            break;

        case ActionTypes.UPDATE_ACTIVE_CARDS:
            let currentCardList = [...state.paymentCards]
            currentCardList.splice(action.payload, 1)
            state = { ...state, paymentCards: currentCardList }
            break;

        default:
            break;
    }

    return state;
}

export default PaymentReducer;